import { Box, Grid } from '@mui/material';
import { JSX } from 'react';

import { SimpleForm } from '@sh4res/bo-common/components/SimpleForm';

import type { SimpleFormProps } from 'react-admin';

const styles = {
  '& .MuiFormControl-root': {
    // MuiFormControl-root is overridden in the theme level to 256px
    width: '100%',
  },
} as const;

export const ActionModalForm = ({
  left,
  right,
  ...other
}: Omit<SimpleFormProps, 'children' | 'toolbar' | 'left' | 'right'> & {
  left: JSX.Element;
  right: JSX.Element;
}) => (
  <SimpleForm
    toolbar={<></>}
    mode="onBlur"
    {...other}
    sx={{
      ...styles,
      ...other.sx,
    }}>
    <Grid container spacing={5}>
      <Grid item xs={6}>
        {left}
      </Grid>
      <Grid item xs={6}>
        <Box sx={{ position: 'sticky', top: '85px' }}>{right}</Box>
      </Grid>
    </Grid>
  </SimpleForm>
);

export const ActionModalFormWithToolbar = ({
  toolbar,
  ...other
}: Omit<SimpleFormProps, 'toolbar'> & {
  toolbar: JSX.Element;
}) => (
  <SimpleForm
    toolbar={toolbar}
    mode="onBlur"
    {...other}
    sx={{
      ...styles,
      ...other.sx,
    }}
  />
);
